// // src/services/cashService.js

// import axiosInstance from './axiosConfig';

// const cashService = {
//   /**
//    * Get cash movements (date + user filtered by backend)
//    * NOW SUPPORTS DATE RANGE
//    */
//   getMovements: async (
//     fromDate,
//     toDate = null,
//     userRole,
//     userId,
//     inventoryId = null,
//     salesPersonId = null
//   ) => {
//     const params = new URLSearchParams();

//     // Add date parameters
//     if (fromDate) params.append('fromDate', fromDate);
//     if (toDate) params.append('toDate', toDate);
//     // If no toDate provided, backend should treat it as single date

//     if (userRole === 'user' && userId) {
//       params.append('userId', userId);
//     }

//     // Future-ready (backend can ignore safely)
//     if (inventoryId && inventoryId !== 'ALL') params.append('inventoryId', inventoryId);
//     if (salesPersonId && salesPersonId !== 'ALL') params.append('salesPersonId', salesPersonId);

//     const response = await axiosInstance.get(
//       `/cash/movements${params.toString() ? '?' + params.toString() : ''}`
//     );

//     return response.data?.data ?? response.data ?? [];
//   },

//   /**
//    * Get cash statistics + inventories + sales persons
//    * NOW SUPPORTS DATE RANGE
//    */
//   getStats: async (fromDate, toDate = null, userRole, userId) => {
//     const params = new URLSearchParams();

//     // Add date parameters
//     if (fromDate) params.append('fromDate', fromDate);
//     if (toDate) params.append('toDate', toDate);

//     if (userRole === 'user' && userId) {
//       params.append('userId', userId);
//     }

//     const response = await axiosInstance.get(
//       `/cash/stats${params.toString() ? '?' + params.toString() : ''}`
//     );

//     return response.data?.data ?? response.data ?? {};
//   },

//   /**
//    * ✨ Get cash movement totals from external API
//    * @param {number} inventoryId - The inventory ID
//    * @param {number} salesPersonId - The sales person ID
//    * @param {string} fromDate - Start date in YYYY-MM-DD format
//    * @param {string} toDate - End date in YYYY-MM-DD format
//    * @returns {Promise} - Returns totals object { CASH, CHEQUE, COLLECTION, ALL }
//    */
//   getCashMovementTotals: async (inventoryId, salesPersonId, fromDate = null, toDate = null) => {
//     try {
//       // Format dates properly - ensure they're YYYY-MM-DD
//       let formattedFromDate;
//       let formattedToDate;
      
//       if (fromDate) {
//         formattedFromDate = fromDate.includes('T') ? fromDate.split('T')[0] : fromDate;
//       } else {
//         formattedFromDate = new Date().toISOString().split('T')[0];
//       }
      
//       if (toDate) {
//         formattedToDate = toDate.includes('T') ? toDate.split('T')[0] : toDate;
//       } else {
//         // If no toDate provided, use fromDate as toDate (single day)
//         formattedToDate = formattedFromDate;
//       }
      
//       // Ensure salesPersonId is valid (not 0 or undefined)
//       const validSalesPersonId = salesPersonId && salesPersonId > 0 ? salesPersonId : 1;
      
//       const params = {
//         inventoryId: inventoryId,
//         salesPerson: validSalesPersonId,
//         fromDate: formattedFromDate,
//         toDate: formattedToDate,
//       };
      
//       // Use axiosInstance which already has the base URL configured
//       const response = await axiosInstance.get('/sales/cashh', { params });

//       // Return only the totals object
//       const totals = response.data?.totals || {
//         CASH: { totalAmount: 0, count: 0 },
//         CHEQUE: { totalAmount: 0, count: 0 },
//         COLLECTION: { totalAmount: 0, count: 0 },
//         ALL: { totalAmount: 0, count: 0 },
//       };
      
//       return totals;
      
//     } catch (error) {
//       // Return default empty totals on error
//       return {
//         CASH: { totalAmount: 0, count: 0 },
//         CHEQUE: { totalAmount: 0, count: 0 },
//         COLLECTION: { totalAmount: 0, count: 0 },
//         ALL: { totalAmount: 0, count: 0 },
//       };
//     }
//   },
  
//   createCashManagement: async (payload) => {
//     try {
//       const response = await axiosInstance.post('/sales/cash-management/create', payload);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   addCheque: async (payload) => {
//     try {
//       const response = await axiosInstance.post('/cheques/create', payload);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   addExpense: async (payload) => {
//     try {
//       const body = {
//         expenses: Array.isArray(payload) ? payload : [payload],
//       };

//       const response = await axiosInstance.post('/expenses/create', body);

//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * Delete movement
//    */
//   deleteMovement: async (movementId) => {
//     return (await axiosInstance.delete(`/cash/movements/${movementId}`)).data;
//   },

//   getCustomers: async () => {
//     const response = await axiosInstance.get('/customers');
//     return response.data.data ?? response.data;
//   },

//   deleteCheque: async (chequeId) => {
//     try {
//       const response = await axiosInstance.delete(`/cheques/delete/${chequeId}`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   deleteExpense: async (expenseId) => {
//     try {
//       const response = await axiosInstance.delete(`/expenses/${expenseId}`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   getReturns: async (exactDate, inventoryId) => {
//     try {
//       const params = new URLSearchParams();
      
//       if (exactDate) {
//         params.append('exactDate', exactDate);
//       }
      
//       if (inventoryId && inventoryId !== 'ALL') {
//         params.append('inventoryId', inventoryId);
//       }

//       const response = await axiosInstance.get(`/returns?${params.toString()}`);

//       // Extract total from response
//       const data = response.data?.data ?? response.data;
      
//       // Calculate total returns amount
//       const totalReturns = Array.isArray(data) 
//         ? data.reduce((sum, item) => sum + (item.amount || 0), 0)
//         : data.total || 0;

//       return totalReturns;

//     } catch (error) {
//       return 0; // Return 0 on error
//     }
//   },

//   getCashManagementData: async (startDate, inventoryId, page = 1, limit = 10) => {
//     try {
//       const response = await axiosInstance.get('/sales/cash-management', {
//         params: {
//           startDate,
//           inventoryId,
//           page,
//           limit
//         }
//       });
      
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// export default cashService;


// src/services/cashService.js

import axiosInstance from './axiosConfig';

const cashService = {
  /**
   * Get cash movements (date + user filtered by backend)
   * NOW SUPPORTS DATE RANGE
   */
  getMovements: async (
    fromDate,
    toDate = null,
    userRole,
    userId,
    inventoryId = null,
    salesPersonId = null
  ) => {
    const params = new URLSearchParams();

    // Add date parameters
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    // If no toDate provided, backend should treat it as single date

    if (userRole === 'user' && userId) {
      params.append('userId', userId);
    }

    // Future-ready (backend can ignore safely)
    if (inventoryId && inventoryId !== 'ALL') params.append('inventoryId', inventoryId);
    if (salesPersonId && salesPersonId !== 'ALL') params.append('salesPersonId', salesPersonId);

    const response = await axiosInstance.get(
      `/cash/movements${params.toString() ? '?' + params.toString() : ''}`
    );

    return response.data?.data ?? response.data ?? [];
  },

  /**
   * Get cash statistics + inventories + sales persons
   * NOW SUPPORTS DATE RANGE
   */
  getStats: async (fromDate, toDate = null, userRole, userId) => {
    const params = new URLSearchParams();

    // Add date parameters
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    if (userRole === 'user' && userId) {
      params.append('userId', userId);
    }

    const response = await axiosInstance.get(
      `/cash/stats${params.toString() ? '?' + params.toString() : ''}`
    );

    return response.data?.data ?? response.data ?? {};
  },

  /**
   * ✨ Get cash movement totals from external API
   * @param {number} inventoryId - The inventory ID
   * @param {number} salesPersonId - The sales person ID
   * @param {string} fromDate - Start date in YYYY-MM-DD format
   * @param {string} toDate - End date in YYYY-MM-DD format
   * @returns {Promise} - Returns totals object { CASH, CHEQUE, COLLECTION, ALL }
   */
  getCashMovementTotals: async (inventoryId, salesPersonId, fromDate = null, toDate = null) => {
    try {
      // Format dates properly - ensure they're YYYY-MM-DD
      let formattedFromDate;
      let formattedToDate;
      
      if (fromDate) {
        formattedFromDate = fromDate.includes('T') ? fromDate.split('T')[0] : fromDate;
      } else {
        formattedFromDate = new Date().toISOString().split('T')[0];
      }
      
      if (toDate) {
        formattedToDate = toDate.includes('T') ? toDate.split('T')[0] : toDate;
      } else {
        // If no toDate provided, use fromDate as toDate (single day)
        formattedToDate = formattedFromDate;
      }
      
      // Ensure salesPersonId is valid (not 0 or undefined)
      const validSalesPersonId = salesPersonId && salesPersonId > 0 ? salesPersonId : 1;
      
      const params = {
        inventoryId: inventoryId,
        salesPerson: validSalesPersonId,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
      };
      
      // Use axiosInstance which already has the base URL configured
      const response = await axiosInstance.get('/sales/cashh', { params });

      // Return only the totals object
      const totals = response.data?.totals || {
        CASH: { totalAmount: 0, count: 0 },
        CHEQUE: { totalAmount: 0, count: 0 },
        COLLECTION: { totalAmount: 0, count: 0 },
        ALL: { totalAmount: 0, count: 0 },
      };
      
      return totals;
      
    } catch (error) {
      // Return default empty totals on error
      return {
        CASH: { totalAmount: 0, count: 0 },
        CHEQUE: { totalAmount: 0, count: 0 },
        COLLECTION: { totalAmount: 0, count: 0 },
        ALL: { totalAmount: 0, count: 0 },
      };
    }
  },
  
  createCashManagement: async (payload) => {
    try {
      const response = await axiosInstance.post('/sales/cash-management/create', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  addCheque: async (payload) => {
    try {
      const response = await axiosInstance.post('/cheques/create', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  addExpense: async (payload) => {
    try {
      const body = {
        expenses: Array.isArray(payload) ? payload : [payload],
      };

      const response = await axiosInstance.post('/expenses/create', body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Delete movement
   */
  deleteMovement: async (movementId) => {
    return (await axiosInstance.delete(`/cash/movements/${movementId}`)).data;
  },

  getCustomers: async () => {
    const response = await axiosInstance.get('/customers');
    return response.data.data ?? response.data;
  },

  deleteCheque: async (chequeId) => {
    try {
      const response = await axiosInstance.delete(`/cheques/delete/${chequeId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteExpense: async (expenseId) => {
    try {
      const response = await axiosInstance.delete(`/expenses/${expenseId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getReturns: async (exactDate, inventoryId) => {
    try {
      const params = new URLSearchParams();
      
      if (exactDate) {
        params.append('exactDate', exactDate);
      }
      
      if (inventoryId && inventoryId !== 'ALL') {
        params.append('inventoryId', inventoryId);
      }

      const response = await axiosInstance.get(`/returns?${params.toString()}`);

      // Extract total from response
      const data = response.data?.data ?? response.data;
      
      // Calculate total returns amount
      const totalReturns = Array.isArray(data) 
        ? data.reduce((sum, item) => sum + (item.amount || 0), 0)
        : data.total || 0;

      return totalReturns;

    } catch (error) {
      return 0; // Return 0 on error
    }
  },

  getCashManagementData: async (inventoryId, startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();

    if (inventoryId) params.append('inventoryId', inventoryId);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const response = await axiosInstance.get(
      `/cashman${params.toString() ? '?' + params.toString() : ''}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
},
};

export default cashService;
